import React, { useCallback, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQueryClient } from '@tanstack/react-query';
import apiFetch from '../../apiClient';
import { avisar } from '../shared/Notificacao';
import { useTheme } from '../../ThemeContext';
import { useEscritorio } from './dadosCasca';
import MenuPrincipal from './MenuPrincipal';
import BarraInferior from './BarraInferior';
import { ouvirAbrirPerfil } from './perfil';
import { usePreferenciaCasca } from './preferencias';

/**
 * Retorno do login com Google (conexão pessoal, iniciada em Perfil e segurança): troca o
 * código pelo token e volta para Perfil e segurança com o resultado. Vem da antiga NavBar.
 * O endereço de retorno é fixo em /configuracoes?google_callback=1, por isso a
 * detecção fica na casca, que está sempre montada.
 */
function useRetornoGoogle(abrir) {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('google_callback') !== '1') return;
    const code = params.get('code');
    const state = params.get('state'); // Necessário para PKCE (code_verifier)
    if (!code) return;
    window.history.replaceState({}, document.title, window.location.pathname);
    const redirectUri = window.location.origin + '/configuracoes?google_callback=1';
    let callbackUrl = `/api/integracoes/google/callback?code=${encodeURIComponent(code)}&redirect_uri=${encodeURIComponent(redirectUri)}`;
    if (state) callbackUrl += `&state=${encodeURIComponent(state)}`;
    apiFetch(callbackUrl).then((resp) => {
      if (!resp.ok) avisar('Não foi possível conectar a conta Google. Tente de novo.', 'erro');
      else avisar('Conta Google conectada.', 'sucesso');
    }).catch(() => {
      avisar('Erro de conexão ao vincular conta Google.', 'erro');
    }).finally(() => {
      abrir();
    });
  }, [abrir]);
}

/**
 * Casca do ERP: menu lateral (quando é a escolha), barra do celular e a conta da
 * pessoa (que abre em Configurações). Aplica a cor principal do escritório, lida da
 * marca, aos tokens do tema. A barra superior e o topo moram no alto da área de
 * conteúdo (routes/index.jsx), como na prancheta.
 */
export default function Casca() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const [navegacao] = usePreferenciaCasca('navegacao');
  const { cor } = useEscritorio();
  const { setCorDoEscritorio } = useTheme();

  useEffect(() => { setCorDoEscritorio?.(cor || null); }, [cor, setCorDoEscritorio]);
  useEffect(() => ouvirAbrirPerfil((secao) => navigate(`/configuracoes/${secao}`)), [navigate]);
  const voltarDoGoogle = useCallback(() => {
    queryClient.invalidateQueries({ queryKey: ['configuracoes', 'google'] });
    navigate('/configuracoes/seguranca');
  }, [queryClient, navigate]);
  useRetornoGoogle(voltarDoGoogle);

  return (
    <>
      {navegacao !== 'superior' && <MenuPrincipal />}
      <BarraInferior />
    </>
  );
}
